
import React, { Component } from 'react'
import { SC } from 'helper/ServerCall';
import { pathSegment } from 'helper/queryString';


export default class Test extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data:  {resource_id: 6, order_folder_id: 2},
			collapseImageUploaderAndViewer: false,
            treeData: [
                { title: '', children: [{ title: '' }] },
                { title: 'Fish', children: [{ title: 'fingerline' }] },
                // { title: 'Dog', children: [{ title: 'fingerline' }] },
              ],
            callData: ''

        }
        // this.test(this.state.data);
         this.show(30089190).then(response =>{
             this.setState({
                 callData: response.data
             });
         })
    }
    test = (data) => {
        return SC.postCall('orderFolder' , data );
    }
    show = (id) => {
        return SC.getCall(`getOrderFolder/${pathSegment(id)}`);
    }
    testEmail = () => {
        return SC.getCall('notify2test' );
    }
    render() {
        const {callData} = this.state;
        let itemId = 1;
        return (
            <div className="text-center mb-md">
                <button type="button" onClick={this.testEmail}>Email Test</button>

            </div>
        )
    }
}
